import { createFileRoute, redirect } from "@tanstack/react-router";

// Back in Warehousing (ADR-048, reverting the move of ADR-046): links from
// that time keep working.
export const Route = createFileRoute("/_app/master-data/locations")({
  beforeLoad: ({ search }) => {
    throw redirect({ to: "/warehousing/locations", search: search as never, replace: true });
  },
});
